const LogList = () => import('@/pages/auth/log/index.vue');

export default [{
    path: '/auth/log',
    component: LogList,
    meta: [{
        name: '权限管理',
		activeRoute: '/auth/manage'
    },
    {
        name: '操作日志',
        activeRoute: '/auth/log'
    }]
}];